module.exports = __webpack_public_path__ + "static/media/VA_Construction_Home_Loans.395b1ab7.png";